import React from 'react'
import { Container, Paper, Grid, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const BeneficiaryVerification = () => {
  const { lang } = useTranslation()
  return (
    <>
      {lang === 'en' ? (
        <Container size="sm">
          <Paper py="lg">
            <Grid gutter="md">
              <Grid.Col span={12}>
                <Text align="left" size="lg" weight="bold">
                  Systems to Verify the Identity of the Beneficiary
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500} style={{ marginBottom: '1rem' }}>
                  To ensure the verification of the beneficiary's identity and
                  provide a smooth and secure registration experience, the
                  following steps can be followed:
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Registration Window (Register - Log in)
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Website Page:</strong> Provide a page on the site
                      that includes “register” and “log in” options.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Separate Windows:</strong> Allocate a window for
                      first-time registration and another window for login for
                      registered users.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Fill Out Participant Information
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Initial Registration:</strong> When registering
                      for the first time, the participant fills out his personal
                      data.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Basic Data:</strong> Must include basic data such
                      as name, email, and phone number.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Email Verification
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Verification Message:</strong> Send a verification
                      message to the beneficiary’s email containing an
                      activation link.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Activation:</strong> The beneficiary must click on
                      the link to activate his account and verify the email.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Registration Form for Courses
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">Full Arabic name</Text>
                  </li>
                  <li>
                    <Text size="md">Full English name</Text>
                  </li>
                  <li>
                    <Text size="md">Email</Text>
                  </li>
                  <li>
                    <Text size="md">Mobile number</Text>
                  </li>
                  <li>
                    <Text size="md">Job</Text>
                  </li>
                  <li>
                    <Text size="md">Specialization</Text>
                  </li>
                  <li>
                    <Text size="md">Educational qualification</Text>
                  </li>
                  <li>
                    <Text size="md">Country</Text>
                  </li>
                  <li>
                    <Text size="md">Region</Text>
                  </li>
                  <li>
                    <Text size="md">City</Text>
                  </li>
                  <li>
                    <Text size="md">Classification number (if any)</Text>
                  </li>
                </ul>
                <Text size="md">
                  <strong>Mandatory Fields:</strong> All fields are mandatory
                  except for the classification number for students.
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Electronic Payment Linked to Beneficiary Information
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Payment Process:</strong> Linking the electronic
                      payment process to the beneficiary’s information.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Unique ID:</strong> Each beneficiary in the
                      e-learning system has a special identification number
                      (ID). Access Data: Complete beneficiary data can be
                      accessed using the identification number.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Submitting Data to the Saudi Commission for Health Specialties
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <Text size="md">
                  After the beneficiary passes the required percentage to obtain
                  the certificate and approved hours of education, his data will
                  be submitted to the Saudi Commission for Health Specialties.
                </Text>
              </Grid.Col>
            </Grid>
          </Paper>
        </Container>
      ) : (
        <Container size="sm">
          <Paper py="lg">
            <Grid gutter="md">
              <Grid.Col span={12}>
                <Text size="lg" weight="bold">
                  أنظمة للتحقق من هوية المستفيد
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  لضمان التحقق من هوية المستفيد وتوفير تجربة تسجيل سلسة وآمنة،
                  يمكن اتباع الخطوات التالية:
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  نافذة خاصة بالتسجيل (تسجيل – تسجيل دخول)
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text size="md">
                      توفير صفحة على الموقع تشمل خيارات "تسجيل" و"تسجيل دخول".
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      تخصيص نافذة للتسجيل لأول مرة وأخرى لتسجيل الدخول
                      للمستخدمين المسجلين.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  تعبئة معلومات المشارك
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text size="md">
                      عند التسجيل لأول مرة، يقوم المشارك بتعبئة بياناته الشخصية.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      يجب أن تتضمن البيانات الأساسية مثل الاسم، البريد
                      الإلكتروني، ورقم الهاتف.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  التحقق عبر البريد الإلكتروني
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text size="md">
                      إرسال رسالة تحقق إلى البريد الإلكتروني للمستفيد تحتوي على
                      رابط تفعيل.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      يتعين على المستفيد النقر على الرابط لتفعيل حسابه والتحقق
                      من صحة البريد الإلكتروني.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  استمارة التسجيل للدورات
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text size="md">
                      بعد اختيار دورة، يقوم المشارك بتعبئة استمارة التسجيل التي
                      تحتوي على :
                    </Text>
                    <ul
                      style={{
                        listStyle: 'inherit',
                        // margin: '16px 0px',
                        padding: '0px 40px 0px 0px',
                      }}
                    >
                      <li>
                        <Text size="md">الاسم العربي بالكامل</Text>
                      </li>
                      <li>
                        <Text size="md">الاسم الإنجليزي بالكامل</Text>
                      </li>
                      <li>
                        <Text size="md">البريد الإلكتروني</Text>
                      </li>
                      <li>
                        <Text size="md">رقم الجوال</Text>
                      </li>
                      <li>
                        <Text size="md">الوظيفة</Text>
                      </li>
                      <li>
                        <Text size="md">التخصص</Text>
                      </li>
                      <li>
                        <Text size="md">المؤهل التعليمي</Text>
                      </li>
                      <li>
                        <Text size="md">البلد</Text>
                      </li>
                      <li>
                        <Text size="md">المنطقة</Text>
                      </li>
                      <li>
                        <Text size="md">المدينة</Text>
                      </li>
                      <li>
                        <Text size="md">رقم التصنيف (إن وجد)</Text>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>الحقول الزامية:</strong> جميع الحقول الزامية ما
                      عدا رقم التصنيف لوجود الطلبة.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  الدفع الإلكتروني المرتبط بمعلومات المستفيد
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text size="md">
                      ربط عملية الدفع الإلكتروني بمعلومات المستفيد.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      لكل مستفيد في نظام التعليم الإلكتروني رقم تعريف (ID) خاص.
                      يمكن الوصول إلى بيانات المستفيد كاملة باستخدام رقم
                      التعريف.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  رفع البيانات إلى الهيئة السعودية للتخصصات الصحية
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <Text size="md">
                  بعد اجتياز المستفيد للنسبة المطلوبة للحصول على الشهادة وساعات
                  التعليم المعتمدة، يتم رفع بياناته إلى الهيئة السعودية للتخصصات
                  الصحية.
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  بتنفيذ هذه الخطوات، يمكن ضمان أمان وسلامة عملية التحقق من هوية
                  المستفيد وتقديم تجربة تسجيل واستخدام مريحة وفعالة.
                </Text>
              </Grid.Col>
            </Grid>
          </Paper>
        </Container>
      )}
    </>
  )
}

export default BeneficiaryVerification
